import React from 'react';
import { ButtonContainer } from './styles'

const ActionButton = ({ text, icon, ...otherProps }) => {
  return (
    <ButtonContainer {...otherProps}>
      {icon}
      {text}
    </ButtonContainer>
  )
}

export default ActionButton;
